/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import * as React from 'react';
import { Agencies } from '@blend/agencies';

import { BlendBridge } from 'blb-types/blendBridge';

export interface Subject {
  agency?: Agencies.API.Agency;
  closing?: EClose.FullClosing;
  loan: BlendBridge.API.Loan | null;
}

export type SubjectContext = Subject | null;

export const SubjectContext = React.createContext<SubjectContext>(null);
